import i18n from '@/plugins/i18n';
import { SelectOption, FileOptionsEnum } from '@/types/types';

export function fileTagOptions(): SelectOption<string>[] {
  return [
    FileOptionsEnum.an,
    FileOptionsEnum.bl,
    FileOptionsEnum.customsPermit,
    FileOptionsEnum.insurance,
    FileOptionsEnum.co,
    FileOptionsEnum.invoice,
    FileOptionsEnum.packingList
  ].map((val: FileOptionsEnum) => {
    return { value: val, label: i18n.t(`tagOptions.${val}`).toString() };
  });
}
